import React from 'react';
import vietnam from '../../assets/packages/vietnam.svg';
import lakshadweep from '../../assets/packages/lakshadweep.svg';
import maldives from '../../assets/packages/maldives.svg';
import mussoorie from '../../assets/packages/mussoorie.svg';
import uttarakhand from '../../assets/packages/uttarakhand.svg';
import { FiArrowUpRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const leftPackages = [
  { name: 'Vietnam', image: vietnam },
  { name: 'Lakshadweep', image: lakshadweep },
  { name: 'Maldives', image: maldives },
  { name: 'Mussoorie', image: mussoorie },
];

const SellingPackage = () => {
  return (
    <div className='bg-[#EFFFF8] pb-12'>
      <div className='container mx-auto px-4 lg:px-16'>
        {/* Heading */}
        <div className='flex items-center justify-between py-8'>
          <p className='text-2xl font-medium leading-tight tracking-normal text-[#495BFF] md:text-[40px]'>
            Best Selling Packages
          </p>
          <Link
            to='/service/holidays'
            className='group flex items-center gap-1 text-[16px] font-semibold text-[#495BFF] md:text-[20px]'
          >
            See all
            <FiArrowUpRight className='transform text-[24px] text-[#55E6A5] transition-transform duration-500 group-hover:rotate-45' />
          </Link>
        </div>

        {/* --- Mobile Layout --- */}
        <div className='grid grid-cols-1 gap-5 sm:grid-cols-2 lg:hidden'>
          {leftPackages.map((pkg, index) => (
            <div
              key={index}
              className='group relative overflow-hidden rounded-lg transition hover:shadow-lg'
            >
              <img
                src={pkg.image}
                alt={pkg.name}
                className='h-56 w-full transform rounded-lg object-cover transition-transform duration-500 ease-in-out group-hover:scale-110'
              />
              <div className='absolute inset-0 bg-black/30'></div>
              <div className='absolute inset-0 flex items-center justify-center'>
                <p className='text-lg font-semibold text-white'>{pkg.name}</p>
              </div>
            </div>
          ))}

          {/* Uttarakhand after others in mobile */}
          <div className='group relative overflow-hidden rounded-lg transition hover:shadow-lg'>
            <img
              src={uttarakhand}
              alt='Uttarakhand'
              className='h-56 w-full transform rounded-lg object-cover transition-transform duration-500 ease-in-out group-hover:scale-110'
            />
            <div className='absolute inset-0 bg-black/30'></div>
            <div className='absolute inset-0 flex items-center justify-center'>
              <p className='text-lg font-semibold text-white'>Uttarakhand</p>
            </div>
          </div>
        </div>

        {/* --- Desktop Layout --- */}
        <div className='hidden grid-cols-1 gap-5 sm:ml-0 lg:grid lg:grid-cols-3'>
          {/* Left Grid: 4 images */}
          <div className='col-span-2 grid grid-cols-1 grid-rows-2 gap-5 sm:grid-cols-2 lg:grid-cols-3'>
            {leftPackages.map((pkg, index) => (
              <div
                key={index}
                className={`group relative col-span-1 overflow-hidden rounded-lg transition hover:shadow-lg sm:col-span-1 ${
                  index === 0 || index === leftPackages.length - 1
                    ? 'lg:col-span-2'
                    : 'lg:col-span-1'
                }`}
              >
                <img
                  src={pkg.image}
                  alt={pkg.name}
                  className='h-56 w-full transform rounded-lg object-cover transition-transform duration-500 ease-in-out group-hover:scale-110 sm:h-64 md:h-64 lg:h-full'
                />
                <div className='absolute inset-0 bg-black/30'></div>
                <div className='absolute inset-0 flex items-center justify-center'>
                  <p className='text-lg font-semibold text-white'>{pkg.name}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Right Grid: Uttarakhand */}
          <div className='group relative overflow-hidden rounded-lg transition hover:shadow-lg'>
            <img
              src={uttarakhand}
              alt='Uttarakhand'
              className='h-56 w-full transform rounded-lg object-cover transition-transform duration-500 ease-in-out group-hover:scale-110 sm:h-full md:h-full lg:h-full'
            />
            <div className='absolute inset-0 bg-black/30'></div>
            <div className='absolute inset-0 flex items-center justify-center'>
              <p className='text-lg font-semibold text-white'>Uttarakhand</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellingPackage;
